/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';

import { Layout, Menu } from 'antd';
import { useTranslation } from 'react-i18next';

import BrandSvg from 'assets/svgs/nightowl-brand-white.svg';
import useGetTestDetails from 'middleware/hcp/test/useGetTestDetails';
import NightN from 'pages/study-viewer/views/night-n';
import { useAnalytics } from 'services/analytics';

import './style.scss';

const { Header, Content } = Layout;

interface RecordingParam {
  key: string;
  value?: string;
  recording: string;
  file?: string;
  testId: string;
}

const DataViewerLayout = () => {
  const { t } = useTranslation();
  const { logDataViewerAccessed, logNightViewed } = useAnalytics();

  const urlParams = new URLSearchParams(decodeURIComponent(window.location.search));
  const recordingsParam = urlParams.get('recordings');
  const key = urlParams.get('test');
  const { test } = useGetTestDetails(key ?? '');

  useEffect(() => {
    if (key) {
      logDataViewerAccessed(key);
    }
  }, [key, logDataViewerAccessed]);

  const item = (test?.recordings ?? []).map((el, index: number) => {
    return {
      label: t('night', { n: index + 1 }),
      key: `night/${el._id}`,
      recording: el._id,
      testId: key ?? '',
      id: `night/${el._id}`,
    };
  });

  const recordings = recordingsParam ? JSON.parse(recordingsParam) : [];
  const recordingItems = recordings.map((el: RecordingParam) => ({
    ...el,
    testId: key,
    label: el.value,
    key: `night/${el.recording}`,
  }));
  const enabledKeys = recordingItems.map((el: RecordingParam) => el.key);
  const [selectedItem, setSelectedItem] = useState<RecordingParam | null>(recordingItems[0]);

  const handleMenuClick = (e: any) => {
    const clickedItem = item.find((item: any) => {
      return String(item.key) === String(e.key);
    });

    if (clickedItem) {
      setSelectedItem(clickedItem);
      const nightIndex = item.findIndex((i: any) => i.key === clickedItem.key) + 1;
      if (key) {
        logNightViewed(key, nightIndex);
      }
    }
  };

  return (
    <Layout className="dv-container">
      <Header className="layoutheader">
        <img id="nightOwl_logo" src={BrandSvg} alt="" className="logo" />
      </Header>
      <div className="dv-header">
        <Menu
          mode="horizontal"
          defaultSelectedKeys={[selectedItem?.key ?? '0']}
          items={item.map((item: any) => ({
            key: item.key,
            label: item.label,
            disabled: !enabledKeys.includes(item.key), // Disable items whose key is not present in recordingItems
            className: enabledKeys.includes(item.key) ? 'enabled-item' : 'disabled-item',
          }))}
          onClick={handleMenuClick}
          className="dv-menu"
        />
      </div>
      <Content style={{ padding: '0 48px' }}>
        {selectedItem && (
          <NightN testId={selectedItem?.testId} recordingId={selectedItem?.recording} />
        )}
      </Content>
    </Layout>
  );
};

export default DataViewerLayout;
